export default "__VITE_ASSET__BNqDkkuD__"